module.exports = __webpack_public_path__ + "static/media/dots.6b4b0105.png";